import React, {ComponentType, FunctionComponent} from 'react';
import {useField} from "formik";
import classNames  from "classnames";

export type FormFieldProps = {
    name: string
    id?: string,
    label?: string
    placeholder?: string,
    markRequired?: boolean
    type?: string
    LeadingIcon?: any,
    rows?: number,
    hint?: string,
    [key: string]: any // ...props
};

const FormField: FunctionComponent<FormFieldProps> = ({
    name,
    label,
    type = 'text',
    placeholder,
    markRequired = false,
    rows = 5,
    LeadingIcon,
    hint,
    ...props
}) => {
    const [field, {touched, error}, helpers] = useField(name);

    const id = props.id ? props.id : name;
    const inputClassNames = classNames(
        'py-3 pr-2 w-full text-ink-60 rounded-md border border-ink-20 focus:border-2 focus:border-brand-100 focus:ring-brand-100 placeholder-ink-40',
        LeadingIcon ? 'pl-10' : 'pl-4',
        error && touched ? 'border-red-500' : ''
    );

    return (
        <div className="space-y-1" {...props}>
            {label ? (
                <label htmlFor={id} className="text-sm text-ink-60 mb-2">
                    {label} {markRequired ? '*' : ''}
                </label>
            ) : null
            }
            <div className="relative">
                { LeadingIcon ? (
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <LeadingIcon className={'w-6 h-6'}/>
                        </div>
                    ) : null
                }
                {
                    type === 'textarea' ? (
                        <textarea {...field} className={inputClassNames} rows={rows} placeholder={placeholder}/>
                    ) : (
                        <input type={type} {...field} id={id} className={inputClassNames} placeholder={placeholder}/>
                    )
                }
                {
                    touched && error ? (
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                 fill="currentColor" aria-hidden="true">
                                <path fillRule="evenodd"
                                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                      clipRule="evenodd"/>
                            </svg>
                        </div>
                    ) : null
                }

            </div>
            {touched && error ? <p className="mt-2 text-sm text-red-600" id="email-error">{error}</p> : null}
            {
                hint ? (
                    <p className={'text-sm text-ink-40 mt-2'}>{hint}</p>
                ) : null
            }
        </div>
    );
};


export default FormField;

